﻿export default [
    {
        step: 'Обновление 1.0.13',
        date: new Date('2019-12-08'),
        text: 'update text'
    },
    {
        step: 'Обновление 1.0.14',
        date: new Date('2019-12-20'),
        file: {
            format: 'PDF',
            path: '/files/инструкция%20mailroom.me.pdf'
        }
    },
    {
        step: 'Обновление 1.1.1',
        date: new Date('2020-04-16'),
        file: {
            format: 'PDF',
            path: '/files/Уведомление%20по%20релизу%201.1.1.pdf'
        }
    },
    {
        step: 'Обновление 1.1.2',
        date: new Date('2020-05-07'),
        file: {
            format: 'PDF',
            path: '/files/Уведомление%20по%20релизу%201.1.2.pdf'
        }
    }
];


//////////////////
// WEBPACK FOOTER
// ./App/constants/shepherdConstants.js
// module id = 543
// module chunks = 0